export const customStyle = {
	statusPopover: {
		paddingTop: "6px",
		paddingBottom: "6px",
		paddingRight: 0,
		paddingLeft: 0,
		border: "none",
	}
};